var AreaActions;
(function (AreaActions) {
    AreaActions["DELETE_AREA"] = "DeleteArea";
    AreaActions["DELETE_RANGE_AREA"] = "DeleteRangeArea";
    AreaActions["FILTER_AREA"] = "FilterArea";
    AreaActions["GET_AREA"] = "GetArea";
    AreaActions["GETWITHDISABLED_AREA"] = "GetWithDisabledArea";
    AreaActions["GET_BY_ID_AREA"] = "GetByIdArea";
    AreaActions["POST_AREA"] = "PostArea";
    AreaActions["PUT_AREA"] = "PutArea";
    AreaActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaArea";
    AreaActions["UPLOAD_PLANILHA"] = "UploadPlanilhaArea";
})(AreaActions || (AreaActions = {}));
var AtividadeActions;
(function (AtividadeActions) {
    AtividadeActions["DELETE_ATIVIDADE"] = "DeleteAtividade";
    AtividadeActions["DELETE_RANGE_ATIVIDADE"] = "DeleteRangeAtividade";
    AtividadeActions["FILTER_ATIVIDADE"] = "FilterAtividade";
    AtividadeActions["GET_ATIVIDADE"] = "GetAtividade";
    AtividadeActions["GETWITHDISABLED_ATIVIDADE"] = "GetWithDisabledAtividade";
    AtividadeActions["GET_BY_ID_ATIVIDADE"] = "GetByIdAtividade";
    AtividadeActions["POST_ATIVIDADE"] = "PostAtividade";
    AtividadeActions["PUT_ATIVIDADE"] = "PutAtividade";
    AtividadeActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaAtividade";
    AtividadeActions["UPLOAD_PLANILHA"] = "UploadPlanilhaAtividade";
})(AtividadeActions || (AtividadeActions = {}));
var CargoMTZActions;
(function (CargoMTZActions) {
    CargoMTZActions["DELETE_CARGO"] = "DeleteCargoMTZ";
    CargoMTZActions["DELETE_RANGE_CARGO"] = "DeleteRangeCargoMTZ";
    CargoMTZActions["FILTER_CARGO"] = "FilterCargoMTZ";
    CargoMTZActions["GET_CARGO"] = "GetCargoMTZ";
    CargoMTZActions["GETWITHDISABLED_CARGO"] = "GetWithDisabledCargoMTZ";
    CargoMTZActions["GET_BY_ID_CARGO"] = "GetByIdCargoMTZ";
    CargoMTZActions["POST_CARGO"] = "PostCargoMTZ";
    CargoMTZActions["PUT_CARGO"] = "PutCargoMTZ";
    CargoMTZActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaCargoMTZ";
    CargoMTZActions["UPLOAD_PLANILHA"] = "UploadPlanilhaCargoMTZ";
    CargoMTZActions["DOWNLOAD_PLANILHA_FUNCAO"] = "DownloadPlanilhaModeloFuncaoCargoMTZ";
    CargoMTZActions["UPLOAD_PLANILHA_FUNCAO"] = "UploadPlanilhaModeloFuncaoCargoMTZ";
    CargoMTZActions["POST_RANGE"] = "PostRange";
})(CargoMTZActions || (CargoMTZActions = {}));
var ConhecimentoActions;
(function (ConhecimentoActions) {
    ConhecimentoActions["DELETE_CONHECIMENTO"] = "DeleteConhecimento";
    ConhecimentoActions["DELETE_RANGE_CONHECIMENTO"] = "DeleteRangeConhecimento";
    ConhecimentoActions["FILTER_CONHECIMENTO"] = "FilterConhecimento";
    ConhecimentoActions["GET_CONHECIMENTO"] = "GetConhecimento";
    ConhecimentoActions["GETWITHDISABLED_CONHECIMENTO"] = "GetWithDisabledConhecimento";
    ConhecimentoActions["GET_BY_ID_CONHECIMENTO"] = "GetByIdConhecimento";
    ConhecimentoActions["POST_CONHECIMENTO"] = "PostConhecimento";
    ConhecimentoActions["PUT_CONHECIMENTO"] = "PutConhecimento";
    ConhecimentoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaConhecimento";
    ConhecimentoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaConhecimento";
    ConhecimentoActions["OBTERCONHECIMENTOSPORCOLABORADOR"] = "ObterConhecimentosPorColaborador";
})(ConhecimentoActions || (ConhecimentoActions = {}));
var FuncaoActions;
(function (FuncaoActions) {
    FuncaoActions["DELETE_FUNCAO"] = "DeleteFuncao";
    FuncaoActions["DELETE_RANGE_FUNCAO"] = "DeleteRangeFuncao";
    FuncaoActions["FILTER_FUNCAO"] = "FilterFuncao";
    FuncaoActions["GET_FUNCAO"] = "GetFuncao";
    FuncaoActions["GETWITHDISABLED_FUNCAO"] = "GetWithDisabledFuncao";
    FuncaoActions["GET_BY_ID_FUNCAO"] = "GetByIdFuncao";
    FuncaoActions["POST_FUNCAO"] = "PostFuncao";
    FuncaoActions["POST_RANGE_FUNCAO"] = "PostRangeFuncao";
    FuncaoActions["PUT_FUNCAO"] = "PutFuncao";
    FuncaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaFuncao";
    FuncaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaFuncao";
    FuncaoActions["DOWNLOAD_PLANILHA_RESP"] = "DownloadPlanilhaFuncaoResp";
    FuncaoActions["UPLOAD_PLANILHA_RESP"] = "UploadPlanilhaFuncaoResp";
    FuncaoActions["DOWNLOAD_PLANILHA_CON"] = "DownloadPlanilhaFuncaoCon";
    FuncaoActions["UPLOAD_PLANILHA_CON"] = "UploadPlanilhaFuncaoCon";
    FuncaoActions["DOWNLOAD_PLANILHA_ATIV"] = "DownloadPlanilhaFuncaoAtiv";
    FuncaoActions["UPLOAD_PLANILHA_ATIV"] = "UploadPlanilhaFuncaoAtiv";
    FuncaoActions["GET_DADOS_POR_FUNCAO_ID"] = "GetDadosPorFuncaoId";
    FuncaoActions["GET_MATRIZ"] = "GetMatriz";
})(FuncaoActions || (FuncaoActions = {}));
var ResponsabilidadeActions;
(function (ResponsabilidadeActions) {
    ResponsabilidadeActions["DELETE_RESPONSABILIDADE"] = "DeleteResponsabilidade";
    ResponsabilidadeActions["DELETE_RANGE_RESPONSABILIDADE"] = "DeleteRangeResponsabilidade";
    ResponsabilidadeActions["FILTER_RESPONSABILIDADE"] = "FilterResponsabilidade";
    ResponsabilidadeActions["GET_RESPONSABILIDADE"] = "GetResponsabilidade";
    ResponsabilidadeActions["GET_STREAM_RESPONSABILIDADE"] = "GetStreamResponsabilidade";
    ResponsabilidadeActions["GETWITHDISABLED_RESPONSABILIDADE"] = "GetWithDisabledResponsabilidade";
    ResponsabilidadeActions["GET_BY_ID_RESPONSABILIDADE"] = "GetByIdResponsabilidade";
    ResponsabilidadeActions["POST_RESPONSABILIDADE"] = "PostResponsabilidade";
    ResponsabilidadeActions["PUT_RESPONSABILIDADE"] = "PutResponsabilidade";
    ResponsabilidadeActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaResponabilidade";
    ResponsabilidadeActions["UPLOAD_PLANILHA"] = "UploadPlanilhaResponsabilidade";
})(ResponsabilidadeActions || (ResponsabilidadeActions = {}));
var ResponsabilidadeAtividadeActions;
(function (ResponsabilidadeAtividadeActions) {
    ResponsabilidadeAtividadeActions["GET_RESPONSABILIDADE_ATIVIDADE_POR_FUNCAO_ID"] = "GetResponsabilidadeAtividadePorFuncaoId";
    ResponsabilidadeAtividadeActions["SALVAR_PARAMETRIZACAO"] = "SalvarParametrizacao";
})(ResponsabilidadeAtividadeActions || (ResponsabilidadeAtividadeActions = {}));
var EquipeActions;
(function (EquipeActions) {
    EquipeActions["DELETE_EQUIPE"] = "DeleteEquipe";
    EquipeActions["DELETE_RANGE_EQUIPE"] = "DeleteRangeEquipe";
    EquipeActions["FILTER_EQUIPE"] = "FilterEquipe";
    EquipeActions["GET_EQUIPE"] = "GetEquipe";
    EquipeActions["GETWITHDISABLED_EQUIPE"] = "GetWithDisabledEquipe";
    EquipeActions["GET_BY_ID_EQUIPE"] = "GetByIdEquipe";
    EquipeActions["POST_EQUIPE"] = "PostEquipe";
    EquipeActions["PUT_EQUIPE"] = "PutEquipe";
    EquipeActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaEquipe";
    EquipeActions["UPLOAD_PLANILHA"] = "UploadPlanilhaEquipe";
})(EquipeActions || (EquipeActions = {}));
var Tipo_ContratacaoActions;
(function (Tipo_ContratacaoActions) {
    Tipo_ContratacaoActions["DELETE_TIPO_CONTRATACAO"] = "DeleteTipo_Contratacao";
    Tipo_ContratacaoActions["DELETE_RANGE_TIPO_CONTRATACAO"] = "DeleteRangeTipo_Contratacao";
    Tipo_ContratacaoActions["FILTER_TIPO_CONTRATACAO"] = "FilterTipo_Contratacao";
    Tipo_ContratacaoActions["GET_TIPO_CONTRATACAO"] = "GetTipo_Contratacao";
    Tipo_ContratacaoActions["GETWITHDISABLED_TIPO_CONTRATACAO"] = "GetWithDisabledTipo_Contratacao";
    Tipo_ContratacaoActions["GET_BY_ID_TIPO_CONTRATACAO"] = "GetByIdTipo_Contratacao";
    Tipo_ContratacaoActions["POST_TIPO_CONTRATACAO"] = "PostTipo_Contratacao";
    Tipo_ContratacaoActions["PUT_TIPO_CONTRATACAO"] = "PutTipo_Contratacao";
})(Tipo_ContratacaoActions || (Tipo_ContratacaoActions = {}));
//********** CÓDIGO GERADO PELO MAKECODEGENERETOR EM: 24/09/2024 02:05:27 **********
var TemaActions;
(function (TemaActions) {
    TemaActions["DELETE_TEMA"] = "DeleteTema";
    TemaActions["DELETE_RANGE_TEMA"] = "DeleteRangeTema";
    TemaActions["FILTER_TEMA"] = "FilterTema";
    TemaActions["GET_TEMA"] = "GetTema";
    TemaActions["GETWITHDISABLED_TEMA"] = "GetWithDisabledTema";
    TemaActions["GET_BY_ID_TEMA"] = "GetByIdTema";
    TemaActions["POST_TEMA"] = "PostTema";
    TemaActions["PUT_TEMA"] = "PutTema";
    TemaActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaTema";
    TemaActions["UPLOAD_PLANILHA"] = "UploadPlanilhaTema";
})(TemaActions || (TemaActions = {}));
var ChecklistActions;
(function (ChecklistActions) {
    ChecklistActions["DELETE_CHECKLIST"] = "DeleteChecklist";
    ChecklistActions["DELETE_RANGE_CHECKLIST"] = "DeleteRangeChecklist";
    ChecklistActions["FILTER_CHECKLIST"] = "FilterChecklist";
    ChecklistActions["GET_CHECKLIST"] = "GetChecklist";
    ChecklistActions["GETWITHDISABLED_CHECKLIST"] = "GetWithDisabledChecklist";
    ChecklistActions["GET_BY_ID_CHECKLIST"] = "GetByIdChecklist";
    ChecklistActions["POST_CHECKLIST"] = "PostChecklist";
    ChecklistActions["POST_RANGE_CHECKLIST"] = "PostRangeChecklist";
    ChecklistActions["PUT_CHECKLIST"] = "PutChecklist";
    ChecklistActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaChecklist";
    ChecklistActions["DOWNLOAD_PLANILHA_PERGUNTA"] = "DownloadPlanilhaModeloPergunta";
    ChecklistActions["UPLOAD_PLANILHA"] = "UploadPlanilhaChecklist";
    ChecklistActions["UPLOAD_PLANILHA_PERGUNTA"] = "UploadPlanilhaModeloPergunta";
})(ChecklistActions || (ChecklistActions = {}));
var ChecklistColaboradorActions;
(function (ChecklistColaboradorActions) {
    ChecklistColaboradorActions["DELETE_CHECKLISTCOLABORADOR"] = "DeleteChecklistColaborador";
    ChecklistColaboradorActions["DELETE_RANGE_CHECKLISTCOLABORADOR"] = "DeleteRangeChecklistColaborador";
    ChecklistColaboradorActions["FILTER_CHECKLISTCOLABORADOR"] = "FilterChecklistColaborador";
    ChecklistColaboradorActions["GET_CHECKLISTCOLABORADOR"] = "GetChecklistColaborador";
    ChecklistColaboradorActions["GETWITHDISABLED_CHECKLISTCOLABORADOR"] = "GetWithDisabledChecklistColaborador";
    ChecklistColaboradorActions["GET_BY_ID_CHECKLISTCOLABORADOR"] = "GetByIdChecklistColaborador";
    ChecklistColaboradorActions["POST_CHECKLISTCOLABORADOR"] = "PostChecklistColaborador";
    ChecklistColaboradorActions["POST_RANGE_CHECKLISTCOLABORADOR"] = "PostRangeChecklistColaborador";
    ChecklistColaboradorActions["PUT_CHECKLISTCOLABORADOR"] = "PutChecklistColaborador";
    ChecklistColaboradorActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaChecklistColaborador";
    ChecklistColaboradorActions["UPLOAD_PLANILHA"] = "UploadPlanilhaChecklistColaborador";
    ChecklistColaboradorActions["ENVIAR_EMAIL"] = "EnviarEmail";
    ChecklistColaboradorActions["FILTER_CHECKLISTCOLABORADOR_BY_LIDER"] = "FilterChecklistColaboradorByLider";
    ChecklistColaboradorActions["ALTERAR_STATUS_CHECKLIST_COLABORADOR"] = "AlterarStatusChecklistColaborador";
})(ChecklistColaboradorActions || (ChecklistColaboradorActions = {}));
var ChecklistPerguntaActions;
(function (ChecklistPerguntaActions) {
    ChecklistPerguntaActions["DELETE_CHECKLISTPERGUNTA"] = "DeleteChecklistPergunta";
    ChecklistPerguntaActions["DELETE_RANGE_CHECKLISTPERGUNTA"] = "DeleteRangeChecklistPergunta";
    ChecklistPerguntaActions["FILTER_CHECKLISTPERGUNTA"] = "FilterChecklistPergunta";
    ChecklistPerguntaActions["GET_CHECKLISTPERGUNTA"] = "GetChecklistPergunta";
    ChecklistPerguntaActions["GETWITHDISABLED_CHECKLISTPERGUNTA"] = "GetWithDisabledChecklistPergunta";
    ChecklistPerguntaActions["GET_BY_ID_CHECKLISTPERGUNTA"] = "GetByIdChecklistPergunta";
    ChecklistPerguntaActions["POST_CHECKLISTPERGUNTA"] = "PostChecklistPergunta";
    ChecklistPerguntaActions["PUT_CHECKLISTPERGUNTA"] = "PutChecklistPergunta";
    ChecklistPerguntaActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaChecklistPergunta";
    ChecklistPerguntaActions["UPLOAD_PLANILHA"] = "UploadPlanilhaChecklistPergunta";
})(ChecklistPerguntaActions || (ChecklistPerguntaActions = {}));
var Nivel_HabilidadeActions;
(function (Nivel_HabilidadeActions) {
    Nivel_HabilidadeActions["DELETE_NIVEL_HABILIDADE"] = "DeleteNivel_Habilidade";
    Nivel_HabilidadeActions["DELETE_RANGE_NIVEL_HABILIDADE"] = "DeleteRangeNivel_Habilidade";
    Nivel_HabilidadeActions["FILTER_NIVEL_HABILIDADE"] = "FilterNivel_Habilidade";
    Nivel_HabilidadeActions["GET_NIVEL_HABILIDADE"] = "GetNivel_Habilidade";
    Nivel_HabilidadeActions["GETWITHDISABLED_NIVEL_HABILIDADE"] = "GetWithDisabledNivel_Habilidade";
    Nivel_HabilidadeActions["GET_BY_ID_NIVEL_HABILIDADE"] = "GetByIdNivel_Habilidade";
    Nivel_HabilidadeActions["POST_NIVEL_HABILIDADE"] = "PostNivel_Habilidade";
    Nivel_HabilidadeActions["PUT_NIVEL_HABILIDADE"] = "PutNivel_Habilidade";
    Nivel_HabilidadeActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaNivel_Habilidade";
    Nivel_HabilidadeActions["UPLOAD_PLANILHA"] = "UploadPlanilhaNivel_Habilidade";
})(Nivel_HabilidadeActions || (Nivel_HabilidadeActions = {}));
var PerguntaActions;
(function (PerguntaActions) {
    PerguntaActions["DELETE_PERGUNTA"] = "DeletePergunta";
    PerguntaActions["DELETE_RANGE_PERGUNTA"] = "DeleteRangePergunta";
    PerguntaActions["FILTER_PERGUNTA"] = "FilterPergunta";
    PerguntaActions["GET_PERGUNTA"] = "GetPergunta";
    PerguntaActions["GETWITHDISABLED_PERGUNTA"] = "GetWithDisabledPergunta";
    PerguntaActions["GET_BY_ID_PERGUNTA"] = "GetByIdPergunta";
    PerguntaActions["POST_PERGUNTA"] = "PostPergunta";
    PerguntaActions["PUT_PERGUNTA"] = "PutPergunta";
    PerguntaActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaPergunta";
    PerguntaActions["UPLOAD_PLANILHA"] = "UploadPlanilhaPergunta";
    PerguntaActions["GET_PERGUNTA_BY_CHECKLIST"] = "GetPerguntaByChecklist";
})(PerguntaActions || (PerguntaActions = {}));
var RespostaChecklistActions;
(function (RespostaChecklistActions) {
    RespostaChecklistActions["DELETE_RESPOSTACHECKLIST"] = "DeleteRespostaChecklist";
    RespostaChecklistActions["DELETE_RANGE_RESPOSTACHECKLIST"] = "DeleteRangeRespostaChecklist";
    RespostaChecklistActions["FILTER_RESPOSTACHECKLIST"] = "FilterRespostaChecklist";
    RespostaChecklistActions["GET_RESPOSTACHECKLIST"] = "GetRespostaChecklist";
    RespostaChecklistActions["GETWITHDISABLED_RESPOSTACHECKLIST"] = "GetWithDisabledRespostaChecklist";
    RespostaChecklistActions["GET_BY_ID_RESPOSTACHECKLIST"] = "GetByIdRespostaChecklist";
    RespostaChecklistActions["POST_RESPOSTACHECKLIST"] = "PostRespostaChecklist";
    RespostaChecklistActions["PUT_RESPOSTACHECKLIST"] = "PutRespostaChecklist";
    RespostaChecklistActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaRespostaChecklist";
    RespostaChecklistActions["UPLOAD_PLANILHA"] = "UploadPlanilhaRespostaChecklist";
    RespostaChecklistActions["ATUALIZAR_RESPOSTAS"] = "AtualizarRespostas";
    RespostaChecklistActions["DELETE_BY_CHECKLISTCOLABORADOR"] = "DeleteByChecklistColaborador";
    RespostaChecklistActions["GET_DADOS_POR_GUID_RESPOSTA"] = "GetDadosPorGuidResposta";
    RespostaChecklistActions["GET_DADOS_POR_GUID_PERGUNTA"] = "GetDadosPorGuidPergunta";
    RespostaChecklistActions["ATUALIZAR_RESPOSTAS_SEM_DELETE"] = "AtualizarRespostasSemDelete";
})(RespostaChecklistActions || (RespostaChecklistActions = {}));
var Colaborador_AvaliacaoActions;
(function (Colaborador_AvaliacaoActions) {
    Colaborador_AvaliacaoActions["DELETE_COLABORADOR_AVALIACAO"] = "DeleteColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["DELETE_RANGE_COLABORADOR_AVALIACAO"] = "DeleteRangeColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["FILTER_COLABORADOR_AVALIACAO"] = "FilterColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["GET_COLABORADOR_AVALIACAO"] = "GetColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["GETWITHDISABLED_COLABORADOR_AVALIACAO"] = "GetWithDisabledColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["GET_BY_ID_COLABORADOR_AVALIACAO"] = "GetByIdColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["POST_COLABORADOR_AVALIACAO"] = "PostColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["PUT_COLABORADOR_AVALIACAO"] = "PutColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaColaborador_Avaliacao";
    Colaborador_AvaliacaoActions["GETNIVELPORCOLABORADORCONHECIMENTO"] = "GetNivelPorColaboradorConhecimento";
})(Colaborador_AvaliacaoActions || (Colaborador_AvaliacaoActions = {}));
var Lista_PresencaActions;
(function (Lista_PresencaActions) {
    Lista_PresencaActions["DELETE_LISTA_PRESENCA"] = "DeleteLista_Presenca";
    Lista_PresencaActions["DELETE_RANGE_LISTA_PRESENCA"] = "DeleteRangeLista_Presenca";
    Lista_PresencaActions["FILTER_LISTA_PRESENCA"] = "FilterLista_Presenca";
    Lista_PresencaActions["GET_LISTA_PRESENCA"] = "GetLista_Presenca";
    Lista_PresencaActions["GETWITHDISABLED_LISTA_PRESENCA"] = "GetWithDisabledLista_Presenca";
    Lista_PresencaActions["GET_BY_ID_LISTA_PRESENCA"] = "GetByIdLista_Presenca";
    Lista_PresencaActions["POST_LISTA_PRESENCA"] = "PostLista_Presenca";
    Lista_PresencaActions["PUT_LISTA_PRESENCA"] = "PutLista_Presenca";
    Lista_PresencaActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaLista_Presenca";
    Lista_PresencaActions["UPLOAD_PLANILHA"] = "UploadPlanilhaLista_Presenca";
})(Lista_PresencaActions || (Lista_PresencaActions = {}));
var TreinamentoActions;
(function (TreinamentoActions) {
    TreinamentoActions["DELETE_TREINAMENTO"] = "DeleteTreinamento";
    TreinamentoActions["DELETE_RANGE_TREINAMENTO"] = "DeleteRangeTreinamento";
    TreinamentoActions["FILTER_TREINAMENTO"] = "FilterTreinamento";
    TreinamentoActions["GET_TREINAMENTO"] = "GetTreinamento";
    TreinamentoActions["GETWITHDISABLED_TREINAMENTO"] = "GetWithDisabledTreinamento";
    TreinamentoActions["GET_BY_ID_TREINAMENTO"] = "GetByIdTreinamento";
    TreinamentoActions["POST_TREINAMENTO"] = "PostTreinamento";
    TreinamentoActions["PUT_TREINAMENTO"] = "PutTreinamento";
    TreinamentoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaTreinamento";
    TreinamentoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaTreinamento";
    TreinamentoActions["SALVA_CONHECIMENTO_ASSOCIADOS"] = "SalvaConhecimentoAssociados";
    TreinamentoActions["BUSCAR_COLABORADORES_POR_CONHECIMENTOS"] = "BuscarColaboradoresPorConhecimentos";
    TreinamentoActions["RECUPERAR_LISTA_PRESENCA"] = "RecuperarListaPresenca";
    TreinamentoActions["SALVAR_COLABORADORES_ASSOCIADOS"] = "SalvarColaboradoresAssociados";
    TreinamentoActions["ATUALIZAR_LISTA_PRESENCA"] = "AtualizarListaPresenca";
})(TreinamentoActions || (TreinamentoActions = {}));
var Treinamento_ColaboradorActions;
(function (Treinamento_ColaboradorActions) {
    Treinamento_ColaboradorActions["DELETE_TREINAMENTO_COLABORADOR"] = "DeleteTreinamento_Colaborador";
    Treinamento_ColaboradorActions["DELETE_RANGE_TREINAMENTO_COLABORADOR"] = "DeleteRangeTreinamento_Colaborador";
    Treinamento_ColaboradorActions["FILTER_TREINAMENTO_COLABORADOR"] = "FilterTreinamento_Colaborador";
    Treinamento_ColaboradorActions["GET_TREINAMENTO_COLABORADOR"] = "GetTreinamento_Colaborador";
    Treinamento_ColaboradorActions["GETWITHDISABLED_TREINAMENTO_COLABORADOR"] = "GetWithDisabledTreinamento_Colaborador";
    Treinamento_ColaboradorActions["GET_BY_ID_TREINAMENTO_COLABORADOR"] = "GetByIdTreinamento_Colaborador";
    Treinamento_ColaboradorActions["POST_TREINAMENTO_COLABORADOR"] = "PostTreinamento_Colaborador";
    Treinamento_ColaboradorActions["PUT_TREINAMENTO_COLABORADOR"] = "PutTreinamento_Colaborador";
    Treinamento_ColaboradorActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaTreinamento_Colaborador";
    Treinamento_ColaboradorActions["UPLOAD_PLANILHA"] = "UploadPlanilhaTreinamento_Colaborador";
})(Treinamento_ColaboradorActions || (Treinamento_ColaboradorActions = {}));
var Treinamento_ConhecimentoActions;
(function (Treinamento_ConhecimentoActions) {
    Treinamento_ConhecimentoActions["DELETE_TREINAMENTO_CONHECIMENTO"] = "DeleteTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["DELETE_RANGE_TREINAMENTO_CONHECIMENTO"] = "DeleteRangeTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["FILTER_TREINAMENTO_CONHECIMENTO"] = "FilterTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["GET_TREINAMENTO_CONHECIMENTO"] = "GetTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["GETWITHDISABLED_TREINAMENTO_CONHECIMENTO"] = "GetWithDisabledTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["GET_BY_ID_TREINAMENTO_CONHECIMENTO"] = "GetByIdTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["POST_TREINAMENTO_CONHECIMENTO"] = "PostTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["PUT_TREINAMENTO_CONHECIMENTO"] = "PutTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaTreinamento_Conhecimento";
    Treinamento_ConhecimentoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaTreinamento_Conhecimento";
})(Treinamento_ConhecimentoActions || (Treinamento_ConhecimentoActions = {}));
/**
 * Estados do ciclo de vida do checklist de um colaborador.
 * Espelho do enum StatusChecklist em
 * Modules.MakeGestao.MatrizDeCompetencia.DTO.Model — mantenha os dois em sincronia.
 *   1 — Pendente   : criado, sem resposta
 *   2 — Submetido  : respondido, aguardando análise
 *   3 — Concluido  : análise finalizada (propaga nível para Colaborador_Avaliacao)
 */
var StatusChecklist;
(function (StatusChecklist) {
    StatusChecklist[StatusChecklist["Pendente"] = 1] = "Pendente";
    StatusChecklist[StatusChecklist["Submetido"] = 2] = "Submetido";
    StatusChecklist[StatusChecklist["Concluido"] = 3] = "Concluido";
})(StatusChecklist || (StatusChecklist = {}));
// Sprint 4 / P23 — dashboard executivo do MTZ.
var DashboardMTZActions;
(function (DashboardMTZActions) {
    DashboardMTZActions["GET_INDICADORES_MTZ"] = "GetIndicadoresMTZ";
})(DashboardMTZActions || (DashboardMTZActions = {}));
export { AreaActions, AtividadeActions, CargoMTZActions, ConhecimentoActions, FuncaoActions, ResponsabilidadeActions, ResponsabilidadeAtividadeActions, EquipeActions, Tipo_ContratacaoActions, TemaActions, ChecklistActions, ChecklistColaboradorActions, ChecklistPerguntaActions, Nivel_HabilidadeActions, PerguntaActions, RespostaChecklistActions, Lista_PresencaActions, TreinamentoActions, Treinamento_ColaboradorActions, Treinamento_ConhecimentoActions, Colaborador_AvaliacaoActions, StatusChecklist, DashboardMTZActions, };
//# sourceMappingURL=mtzEnums.js.map